<!--
 * @Date: 2023-08-25 15:53:42

-->
<template>
  <bk-view class="upcoming-item">
    <statusTag :curRows="item" />

    <res-record-base status="upcoming" :item="item"></res-record-base>

    <bk-view class="view-reason-main" v-if="item.status===2">
			<bk-lang code="appointment_reason" suffix="："></bk-lang>
			<bk-view>{{ item.refuseReason || '-'}}</bk-view>
		</bk-view>
    
    <!-- <bk-view class="date-view">
      <bk-image :src="$bk_getImageUrl('Def_Icon_Calendar_Clock.png')"></bk-image>
      {{ resTime(item?.startDateTime?.displayValue) }}
    </bk-view> -->
  </bk-view>
</template>
  
<script>
	import dayjs from 'dayjs';
	import ResRecordBase from '../resRecordBase/resRecordBase.vue';
	import { dateMap } from '../../dataSource';
	import statusTag from '../statusTag/statusTag.vue';

	export default {
		name: 'UpcomingItem',
		components: { ResRecordBase, statusTag },
		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		data () {
			return {
				languageType: this.$bk_getLanguageType(),
			};
		},

		// computed: {
		// 	resTime () {
		// 		return (date) => {
		// 			const _format = dateMap[this.languageType] || 'MM-DD HH:mm';
		// 			return dayjs(date).format(_format);
		// 		};
		// 	}
		// }
	};
</script>
  
<style lang='less' scoped>
  .upcoming-item {
    min-height: 176px;
    box-shadow: 0px 4px 16px 0px rgba(20,56,149,0.05);
    border-radius: 12px;
    background: #fff;
    padding: 16px;
    margin-bottom: 12px;
    margin-right: 12px;
    >.view-reason-main{
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      border-top: 1px dashed #EFE9E5;
      padding-top: 16px;
      >.bk-view{
        flex: 1;
        .overflowTextLine(1);
      }
    }
    // .date-view {
    //   display: flex;
    //   align-items: center;
    //   height: 48px;
    //   background-color: #F6F7FA;
    //   border-radius: 8px;
    //   margin-top: 14px;
    //   padding-left: 24px;
    //   color: #333;
    //   font-weight: 600;

    //   .bk-image {
    //     width: 24px;
    //     height: 24px;
    //     margin-right: 16px;
    //   }
    // }
  }
</style>